// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bo-4";
export var collapsed = "_bo-1";
export var headerBar = "_bo-0";
export var leftHeaderContent = "_bo-3";
export var subjectContainer = "_bo-2";